/* SINGLE-OFFER MODE (LP-B). One product, one price, one action.
   list           = generally available price, used as the struck-through anchor.
   price          = introductory offer price.
   freeShipping   = shipping is bundled into this offer.
   listIncursShipping = set true ONCE the standard shipping charge is confirmed.
                        It switches the offer block to the stronger
                        "Normally $29.99 + shipping / Today $25 SHIPPED" framing.
                        No dollar amount is stated either way — do not invent one. */
var OFFER={ bars:8, list:29.99, price:24.99, freeShipping:true, listIncursShipping:false };

/* CART — ADDRA 8-Bar Starter Box, variant "8 Count".
   Price ($24.99) and compare-at ($29.99) live on the variant itself, so no
   discount code is needed and none is applied here. */
var CART={ variantId:43066131808352, quantity:1 };

function money(n){return '$'+n.toFixed(2)}
function money0(n){return n%1===0 ? '$'+n : '$'+n.toFixed(2)}
function set(id,v){var el=document.getElementById(id); if(el) el.textContent=v}

function render(){
  set('offerWas',    money(OFFER.list));
  set('offerNow',    money0(OFFER.price));
  set('ctaPrice',    money0(OFFER.price));
  set('finalWas',    money(OFFER.list));
  set('finalNow',    money0(OFFER.price));

  var shipTxt = OFFER.freeShipping ? 'Free shipping' : 'Shipping at checkout';
  set('offerShip', shipTxt);

  var sp=document.getElementById('stickyPrice');
  if(sp){
    sp.innerHTML = money0(OFFER.price) +
      (OFFER.freeShipping ? ' <span class="sticky__ship">· FREE SHIPPING</span>' : '');
  }
  set('stickyLabel', OFFER.bars+' full-size bars');

  var note=document.getElementById('offerShipNote');
  if(note){
    if(OFFER.listIncursShipping && OFFER.freeShipping){
      note.textContent='Normally '+money(OFFER.list)+' + shipping. Today '+money0(OFFER.price)+' SHIPPED.';
      note.hidden=false;
    } else {
      note.hidden=true;
    }
  }
}
render();

/* ---------------------------------------------------------------------------
   ADD TO CART -> CART DRAWER

   Posts to Shopify's AJAX Cart API and then hands off to whatever cart UI the
   theme provides. Themes differ, so this tries each known mechanism in turn
   and only navigates to /cart if none of them exist. Nothing here is
   theme-specific enough to break if you switch themes.
--------------------------------------------------------------------------- */

var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

/* Dawn-family themes re-render sections returned by the add call. Ask only for
   sections that are actually on the page — requesting a section that does not
   exist makes the whole request fail. */
function drawerSections(){
  var ids=[];
  if(document.querySelector('cart-drawer'))      ids.push('cart-drawer');
  if(document.querySelector('cart-notification'))ids.push('cart-notification');
  if(document.querySelector('#cart-icon-bubble'))ids.push('cart-icon-bubble');
  return ids;
}

function openCartUI(data){
  var drawer = document.querySelector('cart-drawer');

  /* 1. Dawn / Refresh / Craft: renderContents paints the new cart and opens it */
  if(drawer && typeof drawer.renderContents === 'function' && data && data.sections){
    drawer.renderContents(data);
    return true;
  }

  /* 2. Newer Dawn and Horizon listen for a refresh event */
  document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
  if(drawer && typeof drawer.open === 'function'){ drawer.open(); return true; }

  /* 3. Widely used third-party theme events */
  document.dispatchEvent(new CustomEvent('cart:build',{bubbles:true}));
  document.dispatchEvent(new CustomEvent('ajaxProduct:added',{bubbles:true}));

  /* 4. Some themes only open the drawer when the cart icon is clicked */
  var icon=document.querySelector('#cart-icon-bubble, .js-drawer-open-cart, [data-cart-drawer-toggle], a[href$="/cart"]');
  if(icon && icon.tagName!=='A'){ icon.click(); return true; }

  return false;
}

function addToCart(label, btn){
  track('add_to_cart', label);

  var restore = null;
  if(btn){
    restore = btn.innerHTML;
    btn.setAttribute('aria-busy','true');
    btn.style.pointerEvents='none';
    btn.textContent='Adding\u2026';
  }
  function done(){
    if(btn && restore!==null){
      btn.innerHTML=restore;
      btn.removeAttribute('aria-busy');
      btn.style.pointerEvents='';
    }
  }

  var payload={ items:[{ id:CART.variantId, quantity:CART.quantity }] };
  var ids=drawerSections();
  if(ids.length) payload.sections=ids;

  fetch(ROOT+'cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify(payload)
  })
  .then(function(r){
    if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||j.message||'add failed'); });
    return r.json();
  })
  .then(function(data){
    done();
    if(!openCartUI(data)) window.location.href=ROOT+'cart';
  })
  .catch(function(err){
    done();
    console.error('[addra] add to cart failed:', err);
    /* Never strand the buyer on a dead button. */
    window.location.href=ROOT+'cart/'+CART.variantId+':'+CART.quantity;
  });
}

document.addEventListener('click',function(e){
  var b=e.target.closest('[data-atc]');
  if(!b) return;
  e.preventDefault();
  addToCart(b.dataset.label||'unlabelled', b);
});

(function(){
  var rail=document.getElementById('galRail'),dots=document.getElementById('galDots'),
      thumbs=document.getElementById('galThumbs'),n=rail.children.length,d='';
  for(var i=0;i<n;i++) d+='<button class="gal__dot'+(i?'':' on')+'" data-i="'+i+'" aria-label="Image '+(i+1)+'"></button>';
  dots.innerHTML=d;
  function go(i){rail.scrollTo({left:rail.clientWidth*i,behavior:'smooth'})}
  [dots,thumbs].forEach(function(h){h.addEventListener('click',function(e){var b=e.target.closest('[data-i]');if(b)go(+b.dataset.i)})});
  rail.addEventListener('scroll',function(){
    var i=Math.round(rail.scrollLeft/rail.clientWidth);
    [dots,thumbs].forEach(function(h){[].forEach.call(h.children,function(el,x){el.classList.toggle('on',x===i)})});
  },{passive:true});
})();
(function(){
  var dlg=document.getElementById('detailsModal');
  document.getElementById('openModal').addEventListener('click',function(){dlg.showModal()});
  document.getElementById('closeModal').addEventListener('click',function(){dlg.close()});
  dlg.addEventListener('click',function(e){if(e.target===dlg)dlg.close()});
  dlg.querySelector('.mdl__tabs').addEventListener('click',function(e){
    var b=e.target.closest('[data-fl]');if(!b)return;
    dlg.querySelectorAll('.mdl__tab').forEach(function(t){t.classList.toggle('on',t===b)});
    dlg.querySelectorAll('.flpanel').forEach(function(pn){pn.classList.toggle('on',pn.dataset.fl===b.dataset.fl)});
  });
})();
(function(){
  var els=document.querySelectorAll('.rv');
  if(!('IntersectionObserver' in window)){[].forEach.call(els,function(e){e.classList.add('on')});return}
  var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('on');io.unobserve(x.target)}})},{threshold:.1,rootMargin:'0px 0px -30px 0px'});
  [].forEach.call(els,function(e){io.observe(e)});
})();
(function(){
  var bar=document.getElementById('sticky'),atc=document.getElementById('atc'),faq=document.getElementById('faq');
  if(!('IntersectionObserver' in window))return;
  var past=false,atFaq=false;
  function sync(){bar.classList.toggle('on',past&&!atFaq)}
  new IntersectionObserver(function(e){past=!e[0].isIntersecting;sync()},{threshold:0}).observe(atc);
  new IntersectionObserver(function(e){atFaq=e[0].isIntersecting;sync()},{threshold:0}).observe(faq);
})();
function track(ev,label){
  var p={event:ev,cta_label:label||'',page_name:'starter_box_offer',
    size:'c8',bars:OFFER.bars,purchase_type:'one_time',frequency:null,
    value:+OFFER.price.toFixed(2)};
  (window.dataLayer=window.dataLayer||[]).push(p);console.log('[track]',p);
}
document.addEventListener('click',function(e){var t=e.target.closest('[data-ev]');if(t&&!t.hasAttribute('data-atc'))track(t.dataset.ev,t.dataset.label)});
document.addEventListener('change',function(e){var t=e.target.closest('[data-ev]');if(t)track(t.dataset.ev,t.dataset.label)});
document.querySelectorAll('.faq details').forEach(function(d){
  d.addEventListener('toggle',function(){if(d.open)track('faq_expand',d.querySelector('summary').textContent)});
});